import React, { useEffect, useState } from "react";
import "./auth.scss";
import {
  Button,
  ButtonWithIcon,
  Checkbox,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  OTPinput,
  Textbox,
  TextButton,
} from "../../ui";
import { B1, L, SLableIcon } from "../../ui/Typography";
import {
  CalenderIcon,
  FacebookIcon,
  GoogleIcon,
  LoadingIcon,
  LoadingSuccess,
  TwitterIcon,
} from "../../ui/icons";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { loginUser, clearAuthError } from "../../redux/reducers/AuthReducer";
import Loading from "../../components/Loading";

function TempLogIn({ isOpen, onClose, onSwitchToSignup }) {
  const dispatch = useDispatch();

  /* === useState === */
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [showLoading, setShowLoading] = useState(false);
  const [loadingTitle, setLoadingTitle] = useState("Log in...");
  const [loadingIcon, setLoadingIcon] = useState(() => LoadingIcon);

  const [isProcessingSuccess, setIsProcessingSuccess] = useState(false); // ✅ NEW: Track success processing

  /* === Redux State === */
  const { loading, error, user } = useSelector((state) => state.auth);

  /* console.log(useSelector((state) => state.auth)); */

  /* === useEffect === */
  useEffect(() => {
    // Clear form & error on modal close
    if (!isOpen) {
      setEmail("");
      setPassword("");
      setEmailError("");
      setPasswordError("");
      dispatch(clearAuthError());
    }
  }, [isOpen]);

  useEffect(() => {
    if (error) {
      console.log("Error occurred");
      setShowLoading(false);
      setIsProcessingSuccess(false);
    }
  }, [error]); // Handle API failure and hide loading if error

  useEffect(() => {
    if (isProcessingSuccess) {
      /* console.log("Login success — changing title/icon");
      console.log("error", error); */
      setLoadingTitle("Login successful");
      setLoadingIcon(() => LoadingSuccess);

      setTimeout(() => {
        /* console.log("Success message shown"); */
        setShowLoading(false);
        setIsProcessingSuccess(false)
        onClose();
      }, 10000);
    }
  }, [isProcessingSuccess]);

  /* === Handlers === */
  const handleLogin = () => {
    let valid = true;
    setEmailError("");
    setPasswordError("");

    if (!email) {
      setEmailError("Email is required");
      valid = false;
    }
    if (!password) {
      setPasswordError("Password is required");
      valid = false;
    }

    if (!valid) return;

    setLoadingTitle("Log in...");
    setLoadingIcon(() => LoadingIcon);
    setShowLoading(true);
    setIsProcessingSuccess(true);
    dispatch(loginUser({ WebEmail: email, WebPass: password }));
  };

  if (showLoading) return <Loading title={loadingTitle} icon={loadingIcon} />;
  return (
    <div className="auth-Wrapper login tamp-login-signup">
      <Modal show={isOpen} onHide={onClose} size="sm">
        <ModalHeader>Sign In</ModalHeader>
        <ModalBody>
          <div className="body-content">
            <div className="top-auth-part">
              <B1 className="text">New User?</B1>
              <TextButton
                size="md"
                variant="secondary"
                onClick={() => {
                  onClose();
                  onSwitchToSignup();
                }}
              >
                Create an account
              </TextButton>
            </div>

            <div className="middle-auth-part">
              <div className="form-group-box">
                <L forInput="loginEmail" className="auth-email-label" size="md">
                  Email address
                </L>
                <Textbox
                  size="lg"
                  icon={CalenderIcon}
                  name="username"
                  placeholder="Enter your email here"
                  className="form-input"
                  id="loginEmail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <SLableIcon size="lg" className={emailError ? "danger" : ""}>
                  {emailError}
                </SLableIcon>

                <L forInput="password" className="auth-email-label" size="md">
                  Password
                </L>
                <Textbox
                  type="password"
                  size="lg"
                  name="password"
                  placeholder="Password"
                  className="form-input"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <SLableIcon size="lg" className={passwordError ? "danger" : ""}>
                  {passwordError}
                </SLableIcon>

                {error && (
                  <SLableIcon size="lg" className="danger">
                    {typeof error === "string" ? error : "Login failed"}
                  </SLableIcon>
                )}

                <div className="remember-me-forgot-pass">
                  <Checkbox
                    id="rememberMe"
                    name="rememberMe"
                    label="Remember me"
                    className="remember-me-checkbox"
                    size="md"
                    onChange={(val) => console.log("Checked:", val)}
                  />
                  <TextButton
                    size="md"
                    className="text-button"
                    variant="secondary"
                  >
                    Forgot password
                  </TextButton>
                </div>

                <Button
                  className="model-button"
                  size="lg"
                  widthSize="full"
                  onClick={handleLogin}
                  disabled={loading || showLoading}
                >
                  {loading || showLoading ? "Please wait..." : "Proceed"}
                </Button>
              </div>
            </div>

            <div className="sign-with-social">
              <B1 className="sign-with-social-title">
                <span>Or Sign in using</span>
              </B1>
              <div className="sign-with-social-icons">
                <ButtonWithIcon size="lg" variant="primary" icon={GoogleIcon} />
                <ButtonWithIcon
                  size="lg"
                  variant="primary"
                  icon={FacebookIcon}
                />
                <ButtonWithIcon
                  size="lg"
                  variant="primary"
                  icon={TwitterIcon}
                />
              </div>
            </div>

            <div className="bottom-auth-part">
              <B1 className="text">
                By Signing up you agree to Seedvms{" "}
                <TextButton
                  size="md"
                  className="text-button"
                  variant="secondary"
                >
                  Privacy Policy
                </TextButton>{" "}
                and{" "}
                <TextButton
                  size="md"
                  className="text-button"
                  variant="secondary"
                >
                  Terms of service
                </TextButton>
              </B1>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default TempLogIn;
